module.exports = __webpack_public_path__ + "static/media/thumbnail_doc6.757f3b1d.png";